import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { anaSponsorlar } from "../sponsorcard/AnaSponsorlar";
import { altinSponsorlar } from "../sponsorcard/AltinSponsorlar";
import { gumusSponsorlar } from "../sponsorcard/GumusSponsorlar";
import { bronzSponsorlar } from "../sponsorcard/BronzSponsorlar";

export default function SimpleSlider() {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 3000,
    lazyLoad: 'ondemand',
    arrows: true,
  };
  return (
    <>
      <div className="clear"></div>

      <div className="container my-5">
        <div className="homeTitle">SPONSORLAR</div>
        <div className="row">
          <div className="col">


            <Slider {...settings}>

              {
                anaSponsorlar.map((sponsor, index) => (
                  <div class="m-3" key={index}>
                    <img
                      width="150px"
                      alt={sponsor?.name}
                      title={sponsor?.name}
                      src={sponsor?.imageUrl}
                    />
                  </div>
                ))
              }
              {
                altinSponsorlar.map((sponsor, index) => (
                  <div class="m-3" key={index}>
                    <img
                      width="150px"
                      alt={sponsor?.name}
                      title={sponsor?.name}
                      src={sponsor?.imageUrl}
                    />
                  </div>
                ))
              }
              {
                gumusSponsorlar.map((sponsor, index) => (
                  <div class="m-3" key={index}>
                    <img
                      width="150px"
                      alt={sponsor?.name}
                      title={sponsor?.name}
                      src={sponsor?.imageUrl}
                    />
                  </div>
                ))
              }
              {
                bronzSponsorlar.map((sponsor, index) => (
                  <div class="m-3" key={index}>
                    <img
                      width="150px"
                      alt={sponsor?.name}
                      title={sponsor?.name}
                      src={sponsor?.imageUrl}
                    />
                  </div>
                ))
              }

            </Slider>
          </div>
        </div>
      </div>
    </>
  );
}